// Куда раскрывать поповер, чтобы он не ушёл за край окна.
//
// Чистая функция без DOM намеренно: happy-dom раскладку не считает вовсе и
// вернул бы нули на любой реализации, то есть тест через настоящий элемент
// зеленел бы и на пустом коде. Здесь на входе числа — и каждое правило
// проверяемо.
//
// ⚠️ Решается ТОЛЬКО выход за вьюпорт. Клиппинг родителем с overflow:hidden
// эта функция не лечит и лечить не может: для него нужен портал в body, а он
// ломает закрытие по composedPath. Ограничение осознанное.
/** Отбив поповера от триггера. Совпадает с `calc(100% + 4px)` в bw-dropdown.css. */
export const POPOVER_GAP = 4;
/** Минимальный зазор до края окна — поповер впритык к краю читается обрезанным. */
export const VIEWPORT_GUTTER = 8;
export function resolvePlacement(input) {
    const { host, popover, viewport } = input;
    // Поповер ещё не измерен (нулевой размер) — двигать нечего, и любое решение
    // здесь было бы принято по несуществующей геометрии.
    if (popover.width <= 0 || popover.height <= 0)
        return { flipX: false, flipY: false };
    const fitsRight = host.left + popover.width <= viewport.width - VIEWPORT_GUTTER;
    // Флип имеет смысл, ТОЛЬКО если на другой стороне место действительно есть.
    // Без этой половины узкое окно получало бы флип, после которого поповер
    // уходит за ЛЕВЫЙ край — то же самое, но зеркально.
    const fitsLeft = host.right - popover.width >= VIEWPORT_GUTTER;
    const fitsBelow = host.bottom + POPOVER_GAP + popover.height <= viewport.height - VIEWPORT_GUTTER;
    const fitsAbove = host.top - POPOVER_GAP - popover.height >= VIEWPORT_GUTTER;
    return {
        flipX: !fitsRight && fitsLeft,
        flipY: !fitsBelow && fitsAbove,
    };
}
//# sourceMappingURL=bw-dropdown-placement.js.map